module.exports = __webpack_public_path__ + "resources/img/img_global_network_gov.23ad8116cab824dbf49d0d75c5f0e1d0.png";